import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { AppRouting } from 'src/pages/app';

export const useGTM = () => {
  const location = useLocation();

  const prevLocationRef = useRef<string | null>(null);

  //const { email, telephone, fullName } = useGeneralSoContext();

  useEffect(() => {
    const pagePath = location.pathname;

    window.dataLayer = window.dataLayer || [];

    const previousPage = prevLocationRef.current || null;

    // Pronalaženje odgovarajućeg pageName
    const findPageName = () => {
      for (const route of AppRouting) {
        const match = matchPath(route.path, location.pathname);
        if (match) {
          return route.pageName;
        }
      }
      return '';
    };

    const pageName = findPageName();

    window.dataLayer.push({
      event: 'virtualPageview',
      pageURL: pagePath,
      pageTitle: pageName,
      previousPage,
      trackingData: {
        category: 'Putno'
      },
    });



  /*  if (pagePath === AppRoutes.PERSONAL_LOAN.CONFIRMATION) {
      window.dataLayer.push({
        event: 'gtmt.priceCheck',
        trackingData: {
          category: 'Krediti',
          action: 'priceCheck',
          label: 'Nenamjenski krediti',
          email,
          telephone,
          fullName
        },
      });
    } */

   
    // Update the previous page reference
    prevLocationRef.current = pagePath;
  }, [location]);
};
